module.exports = __webpack_public_path__ + "bb2.no1.3420683d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/bb2.no1.jpg
// module id = BYlE
// module chunks = 0